import is_page from "./IsPage"
import is_remote_data_table_source from "./IsRemoteDataTableSource"

const is_records_list = {
    mixins: [is_page, is_remote_data_table_source],
    methods: {
        post_load (response) {
            if(!!this.$route.params.remote && (this.state.found === 1)) {
                this.$router.replace({ name: `${this.entity}.edit`, params: { id: this.current_records_ids[0] } })
            }
        }
    }
}

export default is_records_list
